import { getDoubleValue, getIntegerValue, getStringValue, getTimestamp } from "../firestore/firestore.functions";
import { HttpFirestoreDocument } from "../firestore/firestore.types";
import { Brawler, BrawlerStats, BuildItem, HttpFirestoreBrawler, HttpFirestoreBuildItems, Mode, RankedStats } from "./brawler-stats.types";

const COLLECTION_BRAWLER = "brawler"
const DOCUMENT_BRAWLER_PREFIX = "brawler-"

export const getBrawlerStats = async (id: string): Promise<BrawlerStats> => {
  const rankedStats = await getBrawlerStatsFromFirestoreHttp(id)
  return rankedStats
};

const getBrawlerStatsFromFirestoreHttp = async (id: string): Promise<BrawlerStats> => {
  try {
    const brawlerResponse = await fetch(`https://firestore.googleapis.com/v1/projects/topbrawl-d96ec/databases/(default)/documents/${COLLECTION_BRAWLER}/${DOCUMENT_BRAWLER_PREFIX}${id}?key=AIzaSyAHrKlPV1fy5MMksth6i89FcsNf8ZN-yao`);
    const brawlerJson = await brawlerResponse.json();
    const brawlerTyped = brawlerJson as HttpFirestoreDocument<HttpFirestoreBrawler>;
    const brawler = convertHttpFirestoreBrawlerToBrawler(brawlerTyped)
    return brawler
  } catch (error) {
    throw new Error(`${error}: ${id}`);
  }
};

const convertHttpFirestoreBrawlerToBrawler = (firestoreBrawler: HttpFirestoreDocument<HttpFirestoreBrawler>): BrawlerStats => {
  const fields = firestoreBrawler.fields;

  const brawlerFields = fields.brawler.mapValue.fields
  const brawler: Brawler = {
    id: getIntegerValue(brawlerFields.id)!,
    name: getStringValue(brawlerFields.name)!,
    starPowers: getFirestoreBuildItems(brawlerFields.starPowers),
    gadgets: getFirestoreBuildItems(brawlerFields.gadgets),
    gears: getFirestoreBuildItems(brawlerFields.gears),
    statsUpdatedAt: getTimestamp(brawlerFields.statsUpdatedAt)
  };

  const modeStatsFields = fields.modeStats.mapValue.fields
  const modeStats: Mode = {
    modeStats: modeStatsFields.modeStats.arrayValue.values.map(stats => ({
      wins: getIntegerValue(stats.mapValue.fields.wins)!,
      loses: getIntegerValue(stats.mapValue.fields.loses)!,
      totalBattles: getIntegerValue(stats.mapValue.fields.totalBattles)!,
      winRate: getDoubleValue(stats.mapValue.fields.winRate),
      useRate: getDoubleValue(stats.mapValue.fields.useRate),
      effectivityRate: getDoubleValue(stats.mapValue.fields.effectivityRate),
      mode: getStringValue(stats.mapValue.fields.mode)!,
      teamComposition: getStringValue(stats.mapValue.fields.teamComposition)!
    })),
    updatedAt: getTimestamp(modeStatsFields.updatedAt)
  };

  const rankedStatsFields = fields.rankedStats.mapValue.fields
  const rankedStats: RankedStats = {
    rankedStats: rankedStatsFields.rankedStats.arrayValue.values.map(stats => ({
      wins: getIntegerValue(stats.mapValue.fields.wins)!,
      loses: getIntegerValue(stats.mapValue.fields.loses)!,
      totalBattles: getIntegerValue(stats.mapValue.fields.totalBattles)!,
      eventId: getIntegerValue(stats.mapValue.fields.eventId)!,
      winRate: getDoubleValue(stats.mapValue.fields.winRate),
      useRate: getDoubleValue(stats.mapValue.fields.useRate),
      effectivityRate: getDoubleValue(stats.mapValue.fields.effectivityRate),
      mode: getStringValue(stats.mapValue.fields.mode),
      teamComposition: getStringValue(stats.mapValue.fields.teamComposition)
    })),
    updatedAt: getTimestamp(modeStatsFields.updatedAt)
  };

  const brawlerStats: BrawlerStats = {
    brawler: brawler,
    modeStats: modeStats,
    rankedStats: rankedStats
  };

  return brawlerStats;
};

const getFirestoreBuildItems = (field: HttpFirestoreBuildItems): BuildItem[] => {
  return field.arrayValue.values.map(item => ({
    id: getIntegerValue(item.mapValue.fields.id)!,
    name: getStringValue(item.mapValue.fields.name)!,
    buildStats: {
      number: getIntegerValue(item.mapValue.fields.buildStats.mapValue.fields.number)!,
      total: getIntegerValue(item.mapValue.fields.buildStats.mapValue.fields.total)!
    }
  }))
    .sort((a, b) => b.buildStats.number - a.buildStats.number);
}

